<template>
<section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
            <el-form-item>
                <el-input v-model="filters.poolname" placeholder="请输入流量池名称" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item v-if="sysUserName=='管理员'">
                <el-select v-model="filters.serviceid" placeholder="请选择服务商" style="width: 100%;" filterable clearable>
                    <el-option v-for="item in options_servicerman" :label="item.servicerName" :value="item.userid+''" :key="item.userid+''">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="filters.packagecode" placeholder="请选择套餐" style="width: 100%;" filterable clearable>
                    <el-option v-for="item in options_cardtype" :label="item.name" :value="item.code" :key="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" v-on:click="getFlowReportFormList">查询</el-button>
                <el-button type="primary" v-on:click="exportReportForm">导出</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="flowReportForms" highlight-current-row v-loading="listLoading" style="width: 100%;">
        <el-table-column prop="poolname" label="流量池名称" min-width="150">
        </el-table-column>
        <el-table-column prop="servicername" label="服务商" min-width="150">
        </el-table-column>
        <el-table-column prop="gprsSize" label="套餐流量(MB)" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="cardCount" label="卡数量" min-width="150">
        </el-table-column>
        <el-table-column prop="normalCardCount" label="正常卡数量" min-width="150">
        </el-table-column>
        <el-table-column prop="flowTotal" label="流量池总量(MB)" min-width="150">
        </el-table-column>
        <el-table-column prop="flowUsed" label="使用量(MB)" min-width="150">
        </el-table-column>
        <el-table-column prop="flowScale" label="百分比" min-width="150">
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
            <template scope="scope">
                <el-button size="small" @click="handleDetail(scope.$index, scope.row)">查看明细</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
    </el-col>

    <!--明细界面-->
    <el-dialog title="查看明细" :visible.sync="detailFormVisible" :close-on-click-modal="false" @close="editFormHandleClose">
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="detailParam">
                <el-form-item>
					<el-input v-model="detailParam.msisdn" placeholder="输卡号"></el-input>
				</el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="getCardListByFlowpool">查询</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table :data="cards" highlight-current-row v-loading="detailListLoading" style="width: 100%;">
            <el-table-column prop="poolname" label="流量池名称" min-width="150">
            </el-table-column>
            <el-table-column prop="msisdn" label="卡号" min-width="150">
            </el-table-column>
            <el-table-column prop="gprsused" label="已用流量(MB)" min-width="150" sortable>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination @size-change="detailHandleSizeChange" @current-change="detailHandleCurrentChange" :current-page="detailCurrentPage" :page-sizes="[10, 20, 50, 100]" :page-size="detailPageSize" layout="total, sizes, prev, pager, next, jumper" :total="detailTotal" style="float:right;">
            </el-pagination>
        </el-col>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="editFormHandleClose">取消</el-button>
        </div>
    </el-dialog>

</section>
</template>

<script>
import util from '../../common/js/util'
import constant from '../../common/js/constant'
//import NProgress from 'nprogress'
import {
    getFlowReportFormListPage,
    getCardListByFlowpool,
    getUserOneList,
    getAllPackList
} from '../../api/api';

export default {
    data() {
        return {
            dialogVisible: false,
            //查询过滤条件
            filters: {
                //流量池名称
                poolname: '',
                //请选择服务商
                serviceid: '',
                //请选择套餐
                packagecode: ''
            },
            sysUserName: '',
            flowReportForms: [], //分页数据
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            listLoading: false,
            options_servicerman:[],//服务商下拉框
            options_cardtype: [],//套餐下拉框
            detailFormVisible: false, //明细界面是否显示

            detailParam: {
                //卡号
                msisdn: '',
                userid: '',
                flowpoolid:''
            },
            cards: [],
            detailListLoading: false,
            detailTotal: 0, //详情页列表总条数
            detailPageSize: 10, //详情页每页条数
            detailCurrentPage: 1, //详情页当前页码

        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val;
            this.getFlowReportFormList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getFlowReportFormList();
        },
        //获取流量池报表列表
        getFlowReportFormList() {
            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };

            para = Object.assign(para, this.filters);

            this.listLoading = true;

            getFlowReportFormListPage(para).then((res) => {
                this.total = res.data.total;
                this.flowReportForms = res.data.list;
                this.listLoading = false;
            });
        },
        //显示明细界面
        handleDetail: function (index, row) {
            this.detailFormVisible = true;
            this.detailParam.userid = row.userid;
            this.detailParam.flowpoolid = row.id;
            this.getCardListByFlowpool();
        },
        //关闭明细界面触发
        editFormHandleClose: function (done) {
            this.detailFormVisible = false;
            this.cards = [];
            this.detailTotal = 0;
            this.detailPageSize = 10;
            this.detailCurrentPage = 1;
            this.detailParam.msisdn = '';
        },
        detailHandleSizeChange(val) {
            this.detailPageSize = val;
            this.getCardListByFlowpool();
        },
        detailHandleCurrentChange(val) {
            this.detailCurrentPage = val;
            this.getCardListByFlowpool();
        },
        //根据流量池和用户id查询流量池关联卡列表
        getCardListByFlowpool() {
            let para = {
                pageSize: this.detailPageSize,
                pageNum: this.detailCurrentPage
            };

            para = Object.assign(para, this.detailParam);

            this.detailListLoading = true;

            getCardListByFlowpool(para).then((res) => {
                this.detailTotal = res.data.total;
                this.cards = res.data.list;
                this.detailListLoading = false;
            });
        },
        exportReportForm(){
            let para = "";
            para += "poolname=" + this.filters.poolname;
            para += "&serviceid=" + this.filters.serviceid;
            para += "&packagecode=" + this.filters.packagecode;

            location.href = "/api/flowpool/exportFlowReportForm?" + para;
        },

    },
    mounted() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            if (user.userlevel == 0) {
                this.sysUserName = '管理员';
            } else if (user.userlevel == 1) {
                this.sysUserName = '一级服务商';
            } else if (user.userlevel == 2) {
                this.sysUserName = '二级服务商';
            }
        }

        let para = {};
        getAllPackList(para).then((res) => {
            var arr = new Array();
            if(res.data != null && res.data.length >0){
                for(var i=0;i<res.data.length;i++){
                    if(res.data[i].type != '叠加卡'){
                        arr.push(res.data[i]);
                    }
                }
            }
            this.options_cardtype = arr;
        });
        getUserOneList(para).then((res) => {
            this.options_servicerman = res.data;
        });

        this.getFlowReportFormList();
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// flow_reportform.vue?78f48b50